import { DsTabBar, DsTabBarItem } from '@frontends/ds';
import { IbDesk, IbProgramSelect, useIbNavigation } from '@frontends/feature-ib';
import { UiKitEmptyState } from '@frontends/ui-kit';
import { type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import useAuth from '@/hooks/useAuth';
import { IB_DESK_EMBED_PATH } from '@/hooks/useIbDeskSection';
import useIsIbDeskAvailable from '@/hooks/useIsIbDeskAvailable';

export const IbEmbedPage = (): ReactElement | null => {
  const { t } = useTranslation();
  const { client } = useAuth();
  const isIbDeskAvailable = useIsIbDeskAvailable();
  const navigation = useIbNavigation(IB_DESK_EMBED_PATH);
  const selectedItem = navigation.items.find((item) => item.isCurrent) ?? navigation.items[0];

  if (client === undefined) {
    return null;
  }

  if (!isIbDeskAvailable) {
    return (
      <UiKitEmptyState
        align="center"
        icon="lock"
        title={t('ib_desk_unavailable_title')}
        description={t('ib_desk_unavailable_desc')}
      />
    );
  }

  return (
    <>
      <div className="sticky top-0 z-10 flex min-h-12 flex-wrap items-center justify-between gap-x-6 gap-y-2 bg-backgroundCanvas px-4 pb-4 md:px-6">
        <DsTabBar aria-label={t('ib_desk')} selectedKey={selectedItem.id} keyboardActivation="manual">
          {navigation.items.map((item) => (
            <DsTabBarItem key={item.id} id={item.id} href={item.href}>
              {item.label}
            </DsTabBarItem>
          ))}
        </DsTabBar>

        <div className="max-md:order-last max-md:basis-full md:ms-auto">
          <IbProgramSelect />
        </div>
      </div>

      <div className="flex flex-1 flex-col px-4 pb-5 md:px-6">
        <IbDesk />
      </div>
    </>
  );
};
